import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FacilitySection } from '../components/FacilitySection';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
import { Wifi, Coffee, Shield, Users } from 'lucide-react';
export function FacilityPage() {
  const amenities = [{
    icon: Wifi,
    title: 'Free Wi-Fi',
    desc: 'Stay connected while you wait'
  }, {
    icon: Coffee,
    title: 'Parent Lounge',
    desc: 'Comfortable viewing area'
  }, {
    icon: Shield,
    title: 'Safety First',
    desc: 'Professional grade mats & equipment'
  }, {
    icon: Users,
    title: 'Spacious Floor',
    desc: 'Over 3,000 sq ft of training space'
  }];
  return <div className="bg-black min-h-screen" data-id="element-414">
      <Navigation data-id="element-415" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-416">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-417">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-418">
            World-Class <span className="text-[#00D4FF]" data-id="element-419">Facility</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-420">
            Train in a clean, safe, and professional environment designed to
            maximize your potential. Our dojo is your second home.
          </p>
        </motion.div>
      </div>

      <FacilitySection data-id="element-421" />

      {/* Amenities Grid */}
      <section className="py-20 bg-[#111]" data-id="element-422">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-423">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-424">
            Facility Amenities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-425">
            {amenities.map((item, index) => <motion.div key={item.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800 hover:border-[#00D4FF]/50 transition-colors group" data-id="element-426">
                <div className="w-12 h-12 bg-[#00D4FF]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#00D4FF] transition-colors duration-300" data-id="element-427">
                  <item.icon className="w-6 h-6 text-[#00D4FF] group-hover:text-black transition-colors duration-300" data-id="element-428" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-429">
                  {item.title}
                </h3>
                <p className="text-gray-400" data-id="element-430">{item.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-431" />
      <Footer data-id="element-432" />
    </div>;
}